import { useMemo } from 'react';
import { PreviewMediaType } from '@/types';
import type { Preset } from '@/types';

export type PreviewMedia = {
  url: string;
  isVideo: boolean;
  poster?: string;
} | null;

const usePreviewMedia = (selectedPreset: Preset | null): PreviewMedia => {
  return useMemo(() => {
    if (!selectedPreset) return null;

    if (
      selectedPreset.type === PreviewMediaType.VIDEO &&
      selectedPreset.video?.length > 0 &&
      selectedPreset.video[0].media?.url
    ) {
      return {
        url: selectedPreset.video[0].media.url,
        isVideo: true,
        poster: selectedPreset.video?.[0]?.media?.poster,
      };
    }

    if (
      selectedPreset.image?.length > 0 &&
      selectedPreset.image[0].media?.url
    ) {
      return { url: selectedPreset.image[0].media.url, isVideo: false };
    }

    return null;
  }, [selectedPreset]);
};

export default usePreviewMedia;
